import type { QueryClient } from "@tanstack/react-query";
import { useAiChat } from "./ai/store";
import { chatKeys } from "./lib/queryKeys";
import { useConversationPrefs } from "./store/conversationPrefsStore";
import { useChatDrafts } from "./store/draftsStore";
import { useChatEphemeral } from "./store/ephemeralStore";
import { useChatOutbox } from "./store/outboxStore";
import { useChatPopup } from "./store/popupStore";

/**
 * Logout / account switch: nothing of the previous user's chat may survive —
 * cached conversations and messages, signed URLs, typing/presence, drafts
 * and unsent messages (they belong to that user).
 */
export function clearChatData(queryClient: QueryClient): void {
  queryClient.removeQueries({ queryKey: chatKeys.all });
  queryClient.removeQueries({ queryKey: ["official"] });
  useChatEphemeral.getState().reset();
  useChatPopup.getState().close();
  useChatOutbox.getState().clear();
  useChatDrafts.getState().clear();
  useConversationPrefs.getState().clear();
  useAiChat.getState().clear();
}
